// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Paper,
//   Container,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate } from "react-router-dom";

// import { AuthContext } from "../../AuthContext/AuthContext";
// import BottomNavbar from "../../Users/Rent Module/BottomNavbar/BottomNavbar";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";

// const WantedProperties = () => {
//   const navigate = useNavigate();

//   // ✅ Take userId from AuthContext
//   const { userId, logout } = useContext(AuthContext);

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // ✅ userId added to API
//         const res = await axios.get(
//           `https://landnest.net:81/property-request/?userId=${userId}`
//         );

//         setData(res.data);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to load data");
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchData();
//     }
//   }, [userId]);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: `
//           linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
//           url('/construction4.png')
//         `,
//         backgroundSize: "cover",
//         backgroundAttachment: "fixed",
//         pb: 8,
//       }}
//     >
//       {/* ===================== TOP BAR ===================== */}
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{
//           background: `
//             linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
//             url('/construction5.png')
//           `,
//           color: "#fff",
//         }}
//       >
//         <Toolbar sx={{ minHeight: 64 }}>
//           <IconButton
//             edge="start"
//             onClick={() => navigate(-1)}
//             sx={{
//               color: "#ffffff",
//               backgroundColor: "rgba(255,255,255,0.1)",
//               "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
//             }}
//           >
//             <ArrowBackIosNewIcon />
//           </IconButton>

//           <Typography
//             variant="h6"
//             sx={{ marginLeft: 2, fontWeight: 600, color: "#fff" }}
//           >
//             Wanted Properties
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       {/* ===================== CONTENT ===================== */}
//       <Container sx={{ py: 2 }}>
//         {loading && (
//           <Typography align="center" sx={{ mt: 3 }}>
//             Loading...
//           </Typography>
//         )}

//         {error && (
//           <Typography color="error" align="center" sx={{ mt: 3 }}>
//             {error}
//           </Typography>
//         )}

//         {!loading &&
//           !error &&
//           data.map((item) => (
//             <Paper
//               key={item.req_id}
//               sx={{
//                 p: 2,
//                 mb: 2,
//                 borderRadius: "12px",
//                 boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//                 background: "rgba(255,255,255,0.85)",
//                 backdropFilter: "blur(10px)",
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                 Looking For:{" "}
//                 <span style={{ color: "green" }}>{item.looking_for}</span>
//               </Typography>

//               <Typography>
//                 <strong>Location:</strong> {item.location}
//               </Typography>

//               <Typography>
//                 <strong>Property Type:</strong> {item.property_type}
//               </Typography>

//               <Typography>
//                 <strong>Budget:</strong> ₹
//                 {item.min_budget.toLocaleString()} - ₹
//                 {item.max_budget.toLocaleString()}
//               </Typography>

//               {item.min_acres > 0 && (
//                 <Typography>
//                   <strong>Acres:</strong> {item.min_acres} - {item.max_acres}
//                 </Typography>
//               )}

//               {(item.length > 0 || item.width > 0) && (
//                 <Typography>
//                   <strong>Size:</strong> {item.length} × {item.width}{" "}
//                   {item.units}
//                 </Typography>
//               )}

//               <Typography sx={{ opacity: 0.7 }}>
//                 <strong>Comment:</strong> {item.comment}
//               </Typography>

//               <Typography sx={{ opacity: 0.5, fontSize: "12px" }}>
//                 Posted on: {new Date(item.created_at).toLocaleString()}
//               </Typography>
//             </Paper>
//           ))}
//       </Container>

//       {/* ===================== BOTTOM NAV ===================== */}
//       <CustomBottomNavbar />
//     </Box>
//   );
// };

// export default WantedProperties;


import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Container,
  Card,
  CardContent,
  Avatar,
    CircularProgress, // Added for black spinner

} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";

const WantedProperties = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const [responses, setResponses] = useState({});
const [openResponses, setOpenResponses] = useState({});


  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const colors = {
    primary: "#1a1a1a",
    secondary: "#8B7355",
    accent: "#A52A2A",
    background: "#b9a990",
    cardBackground: "#FFFFFF",
    textDark: "#1a1a1a",
    textLight: "#FFFFFF",
    textMuted: "#666666"
  };

useEffect(() => {
  const fetchData = async () => {
    try {
      const [reqRes, respRes] = await Promise.all([
        axios.get(`https://landnest.net:81/property-request/?userId=${userId}`),
        axios.get(`https://landnest.net:81/response-property-request/`)
      ]);

      // filter wanted properties
      const userProperties = reqRes.data
        .filter(item => item.user_id == userId)
        .reverse();

      // group responses by req_id
      const groupedResponses = respRes.data.reduce((acc, item) => {
        if (!acc[item.req_id]) acc[item.req_id] = [];
        acc[item.req_id].push(item);
        return acc;
      }, {});

      setData(userProperties);
      setResponses(groupedResponses);
      setLoading(false);
    } catch (err) {
      setError("Failed to load data");
      setLoading(false);
    }
  };

  if (userId) fetchData();
  else {
    setError("User not authenticated");
    setLoading(false);
  }
}, [userId]);

const formatBudget = (min, max) => {
  if (!min && !max) return "Not specified";
  
  const formatNumber = (num) => {
    const numValue = parseFloat(num) || 0;
    
    if (numValue >= 10000000) { // 1 crore or more
      return `₹${(numValue / 10000000).toFixed(1)} Cr`;
    } else if (numValue >= 1000000) { // 1 million or more
      return `₹${(numValue / 1000000).toFixed(1)} M`;
    } else if (numValue >= 100000) { // 1 lakh or more
      return `₹${(numValue / 100000).toFixed(1)} L`;
    } else if (numValue >= 1000) { // 1 thousand or more
      return `₹${(numValue / 1000).toFixed(1)} K`;
    } else {
      return `₹${numValue}`;
    }
  };
  
  const minNum = parseFloat(min) || 0;
  const maxNum = parseFloat(max) || 0;
  
  if (minNum === maxNum) return formatNumber(minNum);
  
  const minFormatted = formatNumber(minNum);
  const maxFormatted = formatNumber(maxNum);
  
  // If both have same suffix, show only once
  const getSuffix = (str) => {
    if (str.includes('Cr')) return 'Cr';
    if (str.includes('M')) return 'M';
    if (str.includes('L')) return 'L';
    if (str.includes('K')) return 'K';
    return '';
  };
  
  const minSuffix = getSuffix(minFormatted);
  const maxSuffix = getSuffix(maxFormatted);
  
  if (minSuffix && minSuffix === maxSuffix) {
    const minValue = minFormatted.replace(` ${minSuffix}`, '').replace('₹', '');
    const maxValue = maxFormatted.replace(` ${maxSuffix}`, '').replace('₹', '');
    return `₹${minValue}-${maxValue} ${minSuffix}`;
  }
  
  return `${minFormatted} - ${maxFormatted}`;
};

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  };

  const formatDimensions = (property) => {
    if (property.length > 0 && property.width > 0) {
      const area = property.length * property.width;
      const units = property.units || 'ft';
      return `${property.length}*${property.width} (${area}) ${units === 'm' ? 'sq m' : 'sq ft'}`;
    }
    return null;
  };

  const toggleResponse = (reqId) => {
  setOpenResponses(prev => ({
    ...prev,
    [reqId]: !prev[reqId]
  }));
};

const handleViewAllResponses = (property) => {
  navigate("/all-responses", {
    state: {
      responses: responses[property.req_id] || [],
      property
    }
  });
};


  // ==================== BLACK SPINNER WHILE LOADING ====================
  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: 'rgb(239, 231, 221)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading Wanted properties...
        </Typography>
      </Box>
    );
  }
  if (error) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
        <Typography variant="h6" color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
      {/* ===================== TOP BAR ===================== */}
      <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: colors.textLight }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2 }}>Wanted Properties</Typography>
        </Toolbar>
      </AppBar>

      {/* ===================== CONTENT ===================== */}
      <Box sx={{ p: 1.5, flex: 1, pb: 10, backgroundColor: colors.background }}>
        {data.length === 0 ? (
          <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
            No property requests found
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {data.map((property) => (
              <Card key={property.req_id} sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', border: `1px solid #e0e0e0`, overflow: 'hidden' }}>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  {/* Header section */}
                  <Box sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: colors.primary }}>
                    {/* Purchase Section */}
                    <Box sx={{ 
                      backgroundColor: "#b9a990", 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1 }}>
                        {property.looking_for ? property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1) : "Property"}
                      </Typography>
                    </Box>
                    
                    {/* Budget Section */}
                    <Box sx={{ 
                      backgroundColor: colors.cardBackground, 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1, fontSize: '0.9rem' }}>
                        Budget: {formatBudget(property.min_budget, property.max_budget)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ p: 1.5 }}>
                    <Box sx={{ display: 'grid', gap: 0.75 }}>
                      {/* Type */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                          <strong>Property Type:</strong>
                        </Typography>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {property.property_type || "Not specified"}
                        </Typography>
                      </Box>

                      {/* Location */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                          <strong>Location:</strong>
                        </Typography>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {property.location || "Not specified"}
                        </Typography>
                      </Box>

                      {/* Dimensions when available */}
                      {formatDimensions(property) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {formatDimensions(property)}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Fallback to area if dimensions not available */}
                      {(property.area > 0 && !formatDimensions(property)) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {`${property.area} ${property.units || 'sq ft'}`}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Fallback to acres if neither dimensions nor area available */}
                      {((property.min_acres > 0 || property.max_acres > 0) && !formatDimensions(property) && property.area <= 0) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {`${property.min_acres}${property.max_acres > property.min_acres ? `-${property.max_acres}` : ''} acres`}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Ratio */}
                      {property.ratio && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 80, flexShrink: 0 }}>
                            <strong>Ratio:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {property.ratio}
                          </Typography>
                        </Box>
                      )}

                      {/* User and Date */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 0.5 }}>
                        <Avatar sx={{ width: 16, height: 16, fontSize: '0.5rem' }}>
                          👤
                        </Avatar>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 75, flexShrink: 0, ml: 0.5 }}>
                          <strong>CUST {property.user_id}</strong>
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {formatDate(property.created_at)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

{/* ================= RESPONSES ================= */}
{responses[property.req_id]?.length > 0 && (
  <Box sx={{ mt: 1.5, pt: 1, borderTop: '1px dashed #ccc' }}>

    {/* Show / Hide button */}
    <Typography
      onClick={() => toggleResponse(property.req_id)}
      sx={{
        fontSize: '0.75rem',
        fontWeight: 600,
        mb: 0.5,
        cursor: 'pointer',
        color: '#1a1a1a'
      }}
    >
      {openResponses[property.req_id] ? 'Hide Responses' : 'Show Responses'} ({responses[property.req_id].length})
    </Typography>

    {/* Expanded content */}
    {openResponses[property.req_id] && (
      <>
        {/* Show only FIRST response */}
        <Box
          sx={{
            backgroundColor: '#f7f4ef',
            borderRadius: 1,
            p: 0.75,
            mb: 0.5
          }}
        >
          <Typography sx={{ fontSize: '0.75rem' }}>
            {responses[property.req_id][0].comment}
          </Typography>

          {responses[property.req_id][0].proerty_link && (
            <Typography
              component="a"
              href={responses[property.req_id][0].proerty_link}
              target="_blank"
              sx={{
                fontSize: '0.7rem',
                color: '#1a1a1a',
                display: 'block',
                mt: 0.3,
                textDecoration: 'underline'
              }}
            >
              View Property
            </Typography>
          )}

          <Typography sx={{ fontSize: '0.65rem', opacity: 0.6, mt: 0.3 }}>
            {formatDate(responses[property.req_id][0].created_at)}
          </Typography>
        </Box>

        {/* +N more */}
        {responses[property.req_id].length > 1 && (
          <Typography
            onClick={() => handleViewAllResponses(property)}
            sx={{
              fontSize: '0.7rem',
              fontWeight: 600,
              cursor: 'pointer',
              color: '#8B7355'
            }}
          >
            +{responses[property.req_id].length - 1} more
          </Typography>
        )}
      </>
    )}
  </Box>
)}


                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>

      {/* ===================== BOTTOM NAV ===================== */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default WantedProperties;